import React from 'react';

function TablaParalelas(props) {

    function obtenerFilas() {
        props.series.sort((a, b) => a[0].municipality.localeCompare(b[0].municipality));
        return props.series.map((serie, index) => {
            return (
                <tr key={index}>
                    <th scope="row"><div className="rating"><span style={{ backgroundColor: serie[0].color }}></span>&nbsp;&nbsp;{serie[0].municipality}</div></th>
                    {props.ejes.map((eje, index) => {
                        let result = serie.find((serie) => { return serie.category === eje.category })
                        if (result && (result.orgValue || result.orgValue === 0)) {
                            const resultV = Math.round((result.orgValue + Number.EPSILON) * 100) / 100
                            if (eje.orgLimits) {
                                let color = "#e89b37ab"
                                if (eje.orgLimits[1] > eje.orgLimits[0]) {
                                    if (resultV < eje.orgLimits[0]) {
                                        color = "#4d8dd7ab"
                                    } else if (resultV > eje.orgLimits[1]) {
                                        color = "#bcbdc0ab"
                                    }
                                }
                                else {
                                    if (resultV > eje.orgLimits[0]) {
                                        color = "#4d8dd7ab"
                                    } else if (resultV < eje.orgLimits[1]) {
                                        color = "#bcbdc0ab"
                                    }
                                }
                                return <td key={index}>
                                    <div className="ratingCirc"><span style={{ backgroundColor: color }}></span>&nbsp;{resultV + eje.vari.unit}</div>
                                </td>
                            }
                            return <td key={index}>
                                {resultV + eje.vari.unit}
                            </td>
                        }
                        else {
                            return <td key={index}>-</td>
                        }
                    })}
                </tr>
            );
        })
    }

    function obtenerEjes() {

        return props.ejesVisibles.map((eje, index) => {
            if (eje.vari.limits) {
                return (
                    <>
                        <tr key={index * 3}>
                            <th scope="row" rowSpan="3">{eje.category}</th>
                            <td rowSpan="3" className="w-25">{eje.vari.descripcion}</td>
                            <th><div className="rating"><span style={{ backgroundColor: "#4d8dd7ab" }}></span>&nbsp;&nbsp;{eje.vari.titulos[0]}</div></th>
                            <td style={{color:"#4d8dd7"}}>{eje.vari.descripciones[0]}</td>
                        </tr>
                        <tr key={index * 3 + 1}>
                            <th><div className="rating"><span style={{ backgroundColor: "#e89b37ab" }}></span>&nbsp;&nbsp;{eje.vari.titulos[1]}</div></th>
                            <td style={{color:"#e89b37"}}>{eje.vari.descripciones[1]}</td>
                        </tr>
                        <tr key={index * 3 + 2}>
                            <th><div className="rating"><span style={{ backgroundColor: "#bcbdc0ab" }}></span>&nbsp;&nbsp;{eje.vari.titulos[2]}</div></th>
                            <td style={{color:"#acadb0"}}>{eje.vari.descripciones[2]}</td>
                        </tr>
                    </>
                )
            }
            else {
                return (
                    <>
                        <tr key={index}>
                            <th scope="row">{eje.category}</th>
                            <td>{eje.vari.descripcion}</td>
                            <th>&nbsp;</th>
                            <td>&nbsp;</td>
                        </tr>
                    </>
                )
            }
        })
    }

    return (
        <>
            <div className="table-responsive px-4">
                <table className={props.darkMode ? "table table-hover table-dark" : "table table-hover"}>
                    <caption>
                        Los puntos de color al lado de cada valor indican el color de la categoría a la que pertenece el valor: azul, anaranjado o gris.
                    </caption>
                    <thead>
                        <tr>
                            <th scope="col">Región</th>
                            {props.ejes.map((eje, index) => {
                                return (
                                    <th key={index} scope="col">{eje.category}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {obtenerFilas()}
                    </tbody>
                </table>
            </div>

            <br />
            <h5 className="TituloTableroBrechas">Definiciones</h5>
            <div id="containerTabla">
                <div className="table-responsive px-4" id="viewTabla">
                    <table className={props.darkMode ? "table table-hover table-dark" : "table table-hover"}>
                        <caption>
                            Las categorías corresponden a las regiones de color azul, naranja y gris en los ejes de las gráficas. Estas categorías indican los diferentes niveles que existen para un indicador.
                        </caption>
                        <thead>
                            <tr>
                                <th scope="col">Indicador</th>
                                <th scope="col">Descripción</th>
                                <th scope="col">Categoría</th>
                                <th scope="col">Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {obtenerEjes()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default TablaParalelas;